// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { TotalValue } from '../../molecules/total-value';
import { translate } from '@tectonics/translate';

export function ToggleButton(): Node {
  return (
    <Button>
      <Label>
        {translate('volcanes.total')}
      </Label>
      <Value>
        <TotalValue />
      </Value>
    </Button>
  );
}

const Button = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  font-family: ${props => props.theme.fontFamily.display};
`;

const Label = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  height: 36px;
  font-family: ${props => props.theme.fontFamily.display};
`;

const Value = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 24px;
  font-family: ${props => props.theme.fontFamily.display};
  height: 36px;
  color: ${props => props.theme.colors.primary(39)};
`;
